import {Component, OnDestroy, OnInit} from '@angular/core';
import {DialogModel} from '@shared/models/dialog.model';
import {BehaviorSubject, Subject} from 'rxjs';
import {FieldDefinition} from '@shared/models/field-definition';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {takeUntil} from "rxjs/operators";
import {ActivityFilterService} from "../../../../services/activity-filter.service";

@Component({
    standalone: false,
    selector: 'particle-activity-filter-case-selector',
  templateUrl: './activity-filter-case-selector.component.html',
  styleUrls: ['./activity-filter-case-selector.component.scss']
})
export class ActivityFilterCaseSelectorComponent implements OnInit, IDialogView, OnDestroy {
  data: DialogModel;
  fieldDefs = [];
  selectedItems = [];
  itemsLeft$: BehaviorSubject<any[]> = new BehaviorSubject([]);
  itemsRight$: BehaviorSubject<any[]> = new BehaviorSubject([]);
  fieldDefs$: BehaviorSubject<FieldDefinition[]> = new BehaviorSubject([]);
  private unsubscribe$ = new Subject<void>();
  valueChanged: boolean = false;
  allRecords: boolean = false;
  private selectedCases: any[] = [];
  private allCases: any[] = [];

  constructor(private activityFilterService: ActivityFilterService) {
  }

  ngOnInit() {
    this.selectedItems = this.data.input.selectedItems;
    this.allRecords = this.data.input.allRecords;
    if(!this.selectedItems) {
      this.selectedItems = [];
    }
    this.fieldDefs = this.getFieldDefinitions();
    this.fieldDefs$.pipe(takeUntil(this.unsubscribe$));
    this.itemsLeft$.pipe(takeUntil(this.unsubscribe$));
    this.itemsRight$.pipe(takeUntil(this.unsubscribe$));
    this.fieldDefs$.next(this.fieldDefs);
    this.getCases();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onValueChange(event) {
    //console.log('case valuechage');
    this.valueChanged = true;
    this.selectedCases = event.right;
  }

  onOkClicked(): boolean {
    //console.log('[all cases count] ', this.allCases.length, this.selectedItems.length);
    if(this.allRecords && !this.valueChanged) {
      this.data.input.selectedItems = this.allCases.map(c => c.id);
    } else {
      this.data.input.selectedItems = this.valueChanged ? this.selectedCases.map(item => item.id) : this.selectedItems;
    }
    this.data.input.allItemsSelected = this.data.input.selectedItems.length === this.allCases.length;
    return true;
  }

  getFieldDefinitions() {
    return [
      <FieldDefinition>{
        key: 'CaseId',
        header: 'Case ID'
      },
      <FieldDefinition>{
        key: 'Title',
        header: 'Title'
      },
      <FieldDefinition>{
        key: 'Status',
        header: 'Status'
      },
      <FieldDefinition>{
        key: 'CreatedBy',
        header: 'CreatedBy'
      }
    ];
  }

  private getCases() {
    this.activityFilterService.getCases().pipe(takeUntil(this.unsubscribe$)).subscribe(cases => {
      this.allCases = cases;
      this.selectedItems = this.selectedItems.filter(id => this.allCases.findIndex(c => c.id === id) !== -1);
      this.processCases(cases);
      //console.log('[processCases] :',cases);
    });
  }

  private processCases(cases) {
    let rightCases: any[] = [];
    let leftCases: any[] = [];
    if(cases && cases.length > 0) {
      cases.forEach(sCase => {
        if(this.allRecords || (this.selectedItems && this.selectedItems.indexOf(sCase.id) > -1)) {
          rightCases.push(sCase);
        } else {
          leftCases.push(sCase);
        }
      });
    }
    this.itemsLeft$.next(leftCases);
    this.itemsRight$.next(rightCases);
  }
}
